import { createContext } from 'react';
import defaultTranslateFunction from '../utils/default-translate-function.js';
const TranslateFunction = createContext(defaultTranslateFunction);
export default TranslateFunction;
//# sourceMappingURL=translate-function.js.map